var _style, _circle, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCertification(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 194 194",
    style: {
      enableBackground: "new 0 0 194 194"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n\t.st1{fill:#278BC8;}\n\t.st2{fill:#0079C1;}\n")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 97,
    cy: 97,
    r: 97
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M97,0C43.4,0,0,43.4,0,97s43.4,97,97,97s97-43.4,97-97S150.6,0,97,0z M97,172.5c-42.2,0-76.3-34.2-76.3-76.3 S54.8,19.9,97,19.9s76.3,34.2,76.3,76.3S139.2,172.5,97,172.5z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M97,3.4C45.2,3.4,3.4,45.4,3.4,97c0,51.8,42,93.6,93.6,93.6c51.8,0,93.6-42,93.6-93.6 C190.6,45.2,148.8,3.4,97,3.4z M97,169.8c-40.7,0-73.8-33-73.8-73.8s33-73.8,73.8-73.8s73.8,33,73.8,73.8 C170.8,136.9,137.7,169.8,97,169.8z"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M170.8,96.2c0,40.7-33,73.8-73.8,73.8s-73.8-33-73.8-73.8s33-73.8,73.8-73.8S170.8,55.5,170.8,96.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M102.8,31.9c0,0,53.6,3.7,58,59c0,0,1.8,60.9-57.2,73.8c0,0,47-7.4,47-73.8C150.7,90.9,149.7,43,102.8,31.9z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCertification);
export default __webpack_public_path__ + "static/media/certification.3a3fe60ce0158ab91ed668824244e0a4.svg";
export { ForwardRef as ReactComponent };